module.exports = __webpack_public_path__ + "img/BINDI 3 PURPLE.02aa870.svg";